import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";

export default function VirtualActiveEnergyPie({ importVal, exportVal }) {
    const data = [
        { name: "Import", value: importVal || 0 },
        { name: "Export", value: exportVal || 0 },
    ];

    return (
        <div className="bg-white p-5 border rounded-xl shadow">
            <h3 className="text-sm font-semibold mb-3">Aktif Enerji Dağılımı</h3>

            <div className="w-full h-[320px] flex items-center justify-center">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="45%"     // ✔️ Ortalanmış (tam dengeli)
                            outerRadius={100}
                            dataKey="value"
                        >
                            <Cell fill="#10B981" />  {/* Import */}
                            <Cell fill="#F59E0B" />  {/* Export */}
                        </Pie>

                        <Tooltip formatter={(val) => `${Number(val).toFixed(3)} kWh`} />

                        <Legend
                            verticalAlign="bottom"    // ✔️ Alta sabit
                            height={36}               // ✔️ Pie'a girmesini engelle
                            wrapperStyle={{
                                paddingTop: 20,       // ✔️ Pie ile mesafe
                            }}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
